var React = require('react');

function IconmonstrArrow24Outline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"27.5,5.9 21.8,0 13.8,8 5.7,0 0,5.9 13.8,19.5 \t","key":0}),React.createElement("path",{"d":"M1.8,5.9l4-4.1l8,8l8-8l4,4.1l-12,11.9L1.8,5.9z","key":1})])]);
}

IconmonstrArrow24Outline.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 27.5 19.5","style":{"enableBackground":"new 0 0 27.5 19.5"},"xmlSpace":"preserve"};

module.exports = IconmonstrArrow24Outline;

IconmonstrArrow24Outline.default = IconmonstrArrow24Outline;
